module.exports = __webpack_public_path__ + "static/img/3.83fe5d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/3.png
// module id = OPU+
// module chunks = 0